import {createSelector} from '@store/@common';

import {UserId} from 'records/User';
import UserStore from 'stores/UserStore';

const baseUserStore = createSelector(UserStore);

export const users = createSelector([baseUserStore], userStore => userStore.users);

export const getUserById = createSelector([users], list => (userId: UserId) => list.get(userId));
